/* eslint-disable no-use-before-define */
import React, {Component} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {connect} from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'


class UserPicker extends Component {
  
    render(){
        const {multiple = false, users, userOptions, label = 'User', onChange = ()=>{}, defaultValue} = this.props
        const userList = userOptions || users || [];
        
        return (
            <Autocomplete
              id="user-select"
              multiple={multiple}
              options={userList}
              onChange={(event, newValue) => {
                onChange(newValue);
              }}
              defaultValue={defaultValue || (multiple ? [] : {})}
              getOptionLabel={(option) => option.displayName}
              renderInput={(params) => <TextField {...params} label={label} variant="standard" />}
            />
          );
    }

}

const mapStateToProps = (state) =>{
 
    return{
        // users : state.firestore.ordered.users,
        users : state.firestore.ordered.users && state.firestore.ordered.users.map(data => ({displayName : data.displayName, id : data.id})) || [],
        profile: state.firebase.profile,
    }
  }
  
  export default compose(
    connect(mapStateToProps),
    firestoreConnect((props) => {
        return [
          {
            collection: 'users',
            where: ['organization.title', '==', props.profile && props.profile.organization && props.profile.organization.title || 'test']
          }
        ]
    })
  ) (UserPicker)